import { render, staticRenderFns } from "./dataRuleList.vue?vue&type=template&id=c3c10598&scoped=true"
import script from "./dataRuleList.vue?vue&type=script&lang=js"
export * from "./dataRuleList.vue?vue&type=script&lang=js"
import style0 from "./dataRuleList.vue?vue&type=style&index=0&id=c3c10598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c10598",
  null
  
)

export default component.exports